import React, { Component } from 'react';
import { t } from 'ttag';
import connect from 'react-redux/es/connect/connect';
import style from './LanguageSelector.scss';
import LocaleActions from '../../redux/localeRedux';

class LanguageSelector extends Component {
  render = () => (
      <div className={style.container}>
          <div className={style.localeSelection}>
              <p>
                  {
                      /**
               * Do not use translations, because the locale parameter is not set here
               */
                  }
                  <label htmlFor="localizationSelect">
                      {t`Select your localization`}<br />
                      {t`Select your localization2`}<br />
                      {t`Select your localization3`}
                      <br /><br />
                  </label>
              </p>
              <select id="localizationSelect" onChange={(event) => this.props.setLocale(event.target.value)}>
                  <option>
                      {t`Please select ...`}
                  </option>
                  {
                      global.allLanguages.map((language, key) => (
                          <option value={key}>
                              {language}
                          </option>
                      )
                      )
                  }
              </select>
          </div>
      </div>
  );
}

const mapStateToProps = state => ({
    locale: state.locale,
});

const mapDispatchToProps = dispatch => ({
    setLocale: (locale) =>
        dispatch(LocaleActions.setLocale(locale)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector);
